import { useEffect } from "react"

import { useCustomRewardsQuery } from "../../../networking/rewards/queries"
import { localStorageItems } from "../../../util/storage"
import { getScreenTimeConfigurations } from "../../../util/util"
import { useScreenTimeRestrictionFTUXModalStore } from "../ScreenTimeRestrictionFTUXModal"

export const useShowScreenTimeRestrictionFTUXModal = () => {
  const {
    isOpen: isOpenScreenTimeRestrictionFTUXModal,
    onOpen: onOpenScreenTimeRestrictionFTUXModal,
  } = useScreenTimeRestrictionFTUXModalStore()
  const { data: rewards } = useCustomRewardsQuery()
  const rewardWithScreenTime = rewards?.find(
    (reward) =>
      getScreenTimeConfigurations(reward).numLinkedDevices > 0 &&
      reward.assignments.length > 0
  )

  useEffect(() => {
    const hasSeenSTRestrictionFTUXModal = localStorage.getItem(
      localStorageItems.hasSeenSTRestrictionFTUXModal
    )
    if (
      !hasSeenSTRestrictionFTUXModal &&
      !isOpenScreenTimeRestrictionFTUXModal &&
      !!rewardWithScreenTime
    ) {
      onOpenScreenTimeRestrictionFTUXModal(
        rewardWithScreenTime.assignments[0].user_id
      )
    }
  }, []) // eslint-disable-line
}
